import MobileDetect from 'mobile-detect';

const md = new MobileDetect(window.navigator.userAgent);

export function isMobile(){
  return md.mobile();
}

export function isTablet(){
  return md.tablet();
}

export function isMobileOrTablet(){
  return isTablet() || isMobile();
}

export function isDesktop(){
  return !isMobileOrTablet();
}



// WEBPACK FOOTER //
// ./src/utilities/uaDetect.js